import { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "./firebase";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleForgot = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email);
      setError("Password reset link sent to your email.");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleForgot}>
      {/* Email */}
      <div className="form-group">
        <div className="input-group mb-4">
          <div className="input-group-prepend">
            <span className="input-group-text">
              <i className="fa fa-envelope text-gray-400"></i>
            </span>
          </div>
          <input
            type="email"
            className="form-control"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
      </div>

      {/* Error / Success message */}
      {error && <div className="text-danger mb-3">{error}</div>}

      {/* Submit button */}
      <button
        type="submit"
        className="btn btn-primary btn-block mb-3"
        disabled={loading}
      >
        {loading ? "Sending..." : "Send Reset Link"}
      </button>

      {/* Back to Login link */}
      <div className="text-center">
        <button
          type="button"
          className="btn btn-link p-0"
          onClick={() => navigate("/login")}
        >
          Back to Login
        </button>
      </div>
    </form>
  );
};

export default ForgotPassword;
